<template>
    <div
      v-if="showFileUploadModal"
      class="modal-overlay"
      @click="$store.commit('setShowFileUploadModal', false)">
      <div class="modal-content" @click.stop>
        <h2>Upload Details</h2>
        <div class="d-flex flex-direction-column gap-1-rem">
          <div class="file-div"  v-for="file, index in uploadingFiles" :key="index">
            <div class="file-icon-bg">
              <FileIcon/>
            </div>
            <div class="d-flex flex-direction-column w-100 gap-1-rem" style="padding: 1rem">
              {{ file.name }}
              <div class="d-flex w-100 flex-direction-row">
                <div class="file-name-div">
                  <span class="file-name">{{ file.name }}</span>  
                  <span class="file-size"> {{formatFileSize(file.size)}}</span>
                </div>
                <div>
                  <TrashIcon class="trash-icon"/>
                </div>
              </div>
              <div class="d-flex w-100">
                  <div class="progress-bar">
                    <div class="progress-fill" :style="{ width: file.progress + '%' }"></div>
                    {{ file.progress }} wtff
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FileIcon from './icons/FileIcon.vue';
import TrashIcon from './icons/TrashIcon.vue';
export default {
name: "UpoadFileModal", 
  props: {

  },
  components: {
    FileIcon,
    TrashIcon
  },
  computed: {
  ...mapGetters(['selectedProject','showFileUploadModal','uploadingFiles']), // Access Vuex state via getter
  },
  data() {
  return {
  };
  },
  methods: {
    formatFileSize(sizeInBytes) {
      if (sizeInBytes === 0) return '0 Bytes';
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
      const formattedSize = (sizeInBytes / Math.pow(1024, i)).toFixed(2);
      return `${formattedSize} ${sizes[i]}`;
    },
  },
};
</script>


<style scoped>
/* Progress Bar */
.progress-bar {
  background-color: var(--gray-color-2c);
  width: 100%;
  height: 5px;
  border-radius: 5px;
  overflow: hidden;
}
.progress-fill {
  background-color: var(--secondary-color); /* e.g., #00D9F5 */
  height: 100%;
  border-radius: 5px;
  transition: width 0.3s ease;
}

/* Trash Icon */
.trash-icon {
  color: var(--dark-colo-a0);
  padding: 0 1rem;
}

/* File Size & Name */
.file-size {
  font-family: var(--body-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--dark-color-6b);
}
.file-name {
  font-family: var(--body-font);
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--dark-colo-a0);
  flex-grow: 1;
}

/* File Icon & Container */
.file-icon-bg {
  background-color: var(--gray-color-2c);
  border-radius: 5px;
  padding: 15px;
}
.file-icon-bg svg {
  width: 20px;
  height: 20px;
}
.file-div {
  display: flex;
  align-items: center;
  padding: 0 1rem;
  background-color: var(--Theme-Color-Secondary-Black);
  border: 1px solid var(--Border-Color-Primary);
  border-radius: 5px;
}
.file-name-div {
  display: flex;
  flex-grow: 1;
}

/* Modal Header & Text */
h2 {
  margin-bottom: 1rem;
}
.modal-header {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.modal-header-description {
  font-family: var(--body-font);
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
  color: var(--dark-colo-a0);
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex; 
  justify-content: center; 
  align-items: center;
  z-index: 1000;
}

/* Modal Content */
.modal-content {
  background: #121212; /* or var(--Theme-Color-Secondary-Black) */
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
  max-width: 600px;
  width: 90%;
  display: flex;
  flex-direction: column;
}
.modal-content h2 {
  margin-top: 0;
  font-size: 20px;
  color: var(--white-color);
}

/* Modal Actions */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
.modal-actions .secondary,
.modal-actions .primary {
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

</style>